import interceptedAxios from '../../../utils/interceptedAxios'

export interface KeyTypeMappingRequest {
  tenant: string
  keyTypeName: string
}

export async function deactivateKeyMappingService (
  request: KeyTypeMappingRequest,
  onSuccess: (data: any, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/app-config-service/api/v1/crypto/key-mapping'
  try {
    const response = await interceptedAxios.delete(url, {
      data: request
    })
    onSuccess(response.data, response.status)
  } catch (error: any) {
    const status = error?.response?.status ?? 500
    onFailure(error.message ?? 'Unknown error', status)
  }
}
